import { groq } from '#imports';

// Top row of the "Что происходит" section is filled with the latest news
// marked with the isInWhatIsHappening checkbox in Sanity.
const AUTO_NEWS_SECTION_SLUG = 'what-is-happening';
const AUTO_NEWS_COUNT = 4;

const postProjection = `{
        _id,
        _type,
        slug,
        image,
        publishedAt,
        isChronicle,
        size,
        title,
        subtitle,
        titleColor,
        titleColorFromColorPicker,
        subtitleColorFromColorPicker,
        shadowColorFromColorPicker,
        subtitleColor,
        shadowColor,
        isFullImage,
        backgroundColor,
        isArticleExternalSourceType,
        externalSource,
        crew[]{staff->, speciality->}
      }`;

export function getQuery() {
  return groq`*[_type == "section" && !(_id in path('drafts.**'))] | order(position) {
      ...,
      linkedPosts[]->${postProjection},
      "autoNews": select(
        slug.current == "${AUTO_NEWS_SECTION_SLUG}" => *[_type == "news" && isInWhatIsHappening == true && !(_id in path('drafts.**'))] | order(publishedAt desc) [0...${AUTO_NEWS_COUNT}]${postProjection},
        []
      ),
      quoteBlock{..., author->},
    }`;
}

// Marked news go first as big cards, then the manually picked posts.
// News that editors also linked by hand are not duplicated.
export function getSectionPosts(section) {
  const autoNews = (section.autoNews || []).map((news) => ({
    ...news,
    size: 'big',
  }));
  // eslint-disable-next-line no-underscore-dangle
  const autoNewsIds = new Set(autoNews.map((news) => news._id));
  const linkedPosts = (section.linkedPosts || []).filter(
    // eslint-disable-next-line no-underscore-dangle
    (post) => !autoNewsIds.has(post._id)
  );

  return [...autoNews, ...linkedPosts];
}
